export function getRequest(num, id) {
    var url = window.document.location.href.toString();
    const params = {};
    if (url.indexOf('?') != -1) {
        const urls = url.split('?');
        const arr = urls[1].split('&');
        for (let i = 0, l = arr.length; i < l; i++) {
        const a = arr[i].split('=');
        params[a[0]] = a[1];
        }
        if (params.hasOwnProperty(num) && params.hasOwnProperty(id)) {
            return params
        }
    }
}


export function getlogutUrl(geturl) {
    var url = window.document.location.href.toString();
    const params = {};
    if (url.indexOf('?') != -1) {
        const urls = url.split('?');
        const arr = urls[1].split('&');
        for (let i = 0, l = arr.length; i < l; i++) {
        const a = arr[i].split('=');
        params[a[0]] = a[1];
        }
        if (params.hasOwnProperty(geturl)) {
            return params
        }
    }
}

export function getParamsFromHash() {
    var url = window.document.location.href.toString();
    let hash = window.location.hash.substring(1)
    const params = {};
    if (url.indexOf('?_t') != -1) {
        const paramPairs = hash.split('?')[1].split('&');
        for (let i = 0; i < paramPairs.length; i++) {
            const [key, value] = paramPairs[i].split('=');
            params[key] = value;
        }
        return params;
    }
}


export function getAddrParam (name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    } else {
      return null
    }
  }